/*
 * Handing a string to the person at the keyboard.
 *
 * The one piece of "the browser is an operating system" in this client, kept in
 * its own file because that is exactly what it is: the simulation produces a
 * replay as *text* — it has no filesystem and does not want one (rust guide
 * §8.1) — and somebody has to turn text into a file. That somebody is the host,
 * here, in eight lines.
 */

/**
 * Saves text as a file, the way a browser lets one.
 *
 * The object URL is revoked on the next task rather than immediately: Safari
 * historically cancelled the download when the URL went away in the same tick as
 * the click. A timeout of zero is enough, and the alternative — never revoking —
 * pins the whole string in memory for the life of the page.
 */
export function downloadText(filename: string, text: string, type = "application/json"): void {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.click();

  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
